module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_9006.9b638f87.png";